import { render, staticRenderFns } from "./ModalBatchAdd.vue?vue&type=template&id=f3f2cc60&scoped=true"
import script from "./ModalBatchAdd.vue?vue&type=script&lang=js"
export * from "./ModalBatchAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalBatchAdd.vue?vue&type=style&index=0&id=f3f2cc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f2cc60",
  null
  
)

export default component.exports